<template>
  <section class="agents-section section" id="agents">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
          AI能力矩阵
        </div>
        <h2 class="section-title">点石AI <span class="gradient-text">可以帮你做什么</span></h2>
        <p class="section-subtitle">
          提供多智能体协作网，不再单打独斗。随时召唤专属智能体团队，<br>各司其职（写作、运营、分析），协同完成复杂任务。
        </p>
      </div>

      <!-- Agent Cards -->
      <div class="agents-grid">
        <div
          v-for="(agent, i) in agents"
          :key="i"
          class="agent-card"
          :class="{ featured: agent.featured }"
          @mouseenter="activeCard = i"
          @mouseleave="activeCard = null"
        >
          <!-- Background gradient -->
          <div class="card-bg" :style="{ background: agent.gradient }"></div>

          <!-- Icon -->
          <div class="agent-icon-wrap">
            <div class="agent-icon" :style="{ background: agent.iconBg }">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round">
                <path :d="agent.icon"/>
              </svg>
            </div>
            <div class="agent-badge" v-if="agent.badge">{{ agent.badge }}</div>
          </div>

          <!-- Content -->
          <h3 class="agent-title">{{ agent.title }}</h3>
          <p class="agent-desc">{{ agent.desc }}</p>

          <!-- Feature list -->
          <ul class="agent-features">
            <li v-for="feat in agent.features" :key="feat">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              {{ feat }}
            </li>
          </ul>

          <!-- Preview images -->
          <div class="agent-preview">
            <img
              v-for="(img, j) in agent.previewImgs"
              :key="j"
              :src="img"
              :alt="agent.title"
              class="preview-img"
              :style="{ transform: `rotate(${(j-1)*4}deg) translateY(${j*-4}px)`, zIndex: agent.previewImgs.length - j }"
            />
          </div>

          <!-- CTA -->
          <router-link :to="agent.ctaTo" class="agent-cta" @click.native.stop>
            立即使用
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </router-link>
        </div>
      </div>

      <!-- Bottom stats bar -->
      <div class="agents-stats">
        <div v-for="s in agentStats" :key="s.label" class="agents-stat">
          <div class="agents-stat-icon" :style="{ background: s.color }">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path :d="s.icon"/></svg>
          </div>
          <div>
            <div class="agents-stat-val">{{ s.val }}</div>
            <div class="agents-stat-label">{{ s.label }}</div>
          </div>
        </div>
      </div>

      <!-- Section CTA -->
      <div class="section-cta">
        <router-link :to="AGENTS_PLAZA" class="btn-primary">立即体验</router-link>
        <a href="#" class="btn-outline">预约课程</a>
      </div>
    </div>
  </section>
</template>

<script>
import { AGENTS_PLAZA, AGENTS_WRITING, AGENTS_ASSISTANT } from '@/constants/homeNav'

export default {
  name: 'AgentsSection',
  data() {
    return {
      AGENTS_PLAZA,
      activeCard: null,
      agents: [
        {
          title: '文案创作',
          ctaTo: AGENTS_WRITING,
          desc: '满足全行业多场景文案内容创作，一个人顶一支文案策划团队。',
          icon: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z',
          iconBg: 'linear-gradient(135deg,#2563EB,#06B6D4)',
          gradient: 'linear-gradient(135deg, rgba(37,99,235,0.06) 0%, rgba(6,182,212,0.04) 100%)',
          badge: '热门',
          featured: false,
          features: ['小红书爆款图文', '抖音短视频脚本', '产品卖点提炼', '营销活动文案', '品牌故事创作'],
          previewImgs: [
            'https://picsum.photos/seed/agent11/280/160',
            'https://picsum.photos/seed/agent12/280/160',
            'https://picsum.photos/seed/agent13/280/160',
          ]
        },
        {
          title: '创意短视频',
          ctaTo: AGENTS_ASSISTANT,
          desc: '批量生成多种创意短视频，支持口播、宣传片、信息流、混剪、图视、数字人等多种视频类型。',
          icon: 'M15 10l4.553-2.069A1 1 0 0121 8.87v6.26a1 1 0 01-1.447.9L15 14M3 8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z',
          iconBg: 'linear-gradient(135deg,#7C3AED,#EC4899)',
          gradient: 'linear-gradient(135deg, rgba(124,58,237,0.06) 0%, rgba(236,72,153,0.04) 100%)',
          badge: 'SVIP',
          featured: true,
          features: ['口播视频生成', '品牌宣传片', '信息流广告', '混剪创作', '数字人视频', '图文视频'],
          previewImgs: [
            'https://picsum.photos/seed/agent21/280/160',
            'https://picsum.photos/seed/agent22/280/160',
            'https://picsum.photos/seed/agent23/280/160',
          ]
        },
        {
          title: '办公助手',
          ctaTo: AGENTS_ASSISTANT,
          desc: '各行业、工种智能体助手开箱即用，随时雇佣你的数字员工。',
          icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75',
          iconBg: 'linear-gradient(135deg,#0EA5E9,#10B981)',
          gradient: 'linear-gradient(135deg, rgba(14,165,233,0.06) 0%, rgba(16,185,129,0.04) 100%)',
          badge: '新增',
          featured: false,
          features: ['财务报表分析', '客服智能应答', '招聘面试助手', '市场调研报告', '项目管理协作'],
          previewImgs: [
            'https://picsum.photos/seed/agent31/280/160',
            'https://picsum.photos/seed/agent32/280/160',
            'https://picsum.photos/seed/agent33/280/160',
          ]
        }
      ],
      agentStats: [
        { val: '500+', label: 'AI智能体', color: 'linear-gradient(135deg,#2563EB,#60A5FA)', icon: 'M12 2a10 10 0 110 20 10 10 0 010-20z' },
        { val: '1000+', label: '工作流模板', color: 'linear-gradient(135deg,#7C3AED,#A855F7)', icon: 'M3 7h18M3 12h18M3 17h12' },
        { val: '20×', label: '效率提升', color: 'linear-gradient(135deg,#0EA5E9,#06B6D4)', icon: 'M22 7L13.5 15.5 8.5 10.5 2 17' },
        { val: '24/7', label: '全天候服务', color: 'linear-gradient(135deg,#F59E0B,#EF4444)', icon: 'M12 2v10l6 3' },
        { val: '10万+', label: '企业用户', color: 'linear-gradient(135deg,#10B981,#059669)', icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8z' },
      ]
    }
  }
}
</script>

<style scoped>
.agents-section { background: var(--bg); }

.section-header {
  text-align: center;
  margin-bottom: 56px;
}
.section-header .section-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
}

.agents-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 48px;
}

.agent-card {
  position: relative;
  background: var(--bg-card);
  border: 1.5px solid var(--border);
  border-radius: 24px;
  padding: 32px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.agent-card:hover {
  transform: translateY(-6px);
  border-color: var(--primary);
  box-shadow: var(--shadow-lg);
}
.agent-card.featured {
  border-color: var(--primary);
  background: var(--gradient-card);
}
.agent-card.featured::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: var(--gradient-brand);
}

.card-bg {
  position: absolute;
  inset: 0;
  opacity: 0.5;
  transition: opacity 0.3s;
}
.agent-card:hover .card-bg { opacity: 1; }

.agent-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}
.agent-icon {
  width: 56px; height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}
.agent-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 10px;
  background: var(--gradient-brand);
  color: white;
  border-radius: 100px;
  position: relative;
  z-index: 1;
}

.agent-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text);
  position: relative;
  z-index: 1;
}

.agent-desc {
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.7;
  position: relative;
  z-index: 1;
}

.agent-features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 1;
  flex: 1;
}
.agent-features li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.84rem;
  color: var(--text-secondary);
  font-weight: 500;
}
.agent-features li svg { color: var(--primary); flex-shrink: 0; }

.agent-preview {
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.preview-img {
  position: absolute;
  width: 120px;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid var(--bg-card);
  box-shadow: var(--shadow);
  transition: all 0.3s ease;
}
.agent-card:hover .preview-img:first-child { transform: rotate(-8deg) translateY(-8px) !important; }
.agent-card:hover .preview-img:last-child { transform: rotate(8deg) translateY(-8px) !important; }

.agent-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: 12px;
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
}
.agent-card:hover .agent-cta {
  background: var(--primary);
  color: white;
}

/* Stats bar */
.agents-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 40px;
  background: var(--bg-card);
  border: 1.5px solid var(--border);
  border-radius: 20px;
  margin-bottom: 40px;
  gap: 16px;
  flex-wrap: wrap;
}
.agents-stat {
  display: flex;
  align-items: center;
  gap: 12px;
}
.agents-stat-icon {
  width: 40px; height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.agents-stat-val {
  font-size: 1.3rem;
  font-weight: 800;
  background: var(--gradient-brand);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
}
.agents-stat-label { font-size: 0.75rem; color: var(--text-muted); margin-top: 3px; }

.section-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

@media (max-width: 900px) {
  .agents-grid { grid-template-columns: 1fr; max-width: 480px; margin: 0 auto 48px; }
  .agents-stats { justify-content: center; gap: 24px; }
}
@media (max-width: 640px) {
  .agent-card { padding: 24px; }
  .agents-stats { padding: 20px; }
  .agents-stat-val { font-size: 1.1rem; }
}
</style>
